import {
  allPass,
  eq,
  every,
  filter,
  flow,
  get,
  identity,
  ifThen,
  isFilled,
  isNumber,
  map,
  negate,
  split,
  toUndefinedIfEmpty,
  trim,
} from '@yandex-delivery/utils'

export const isValidCoordinates: (coordinates?: unknown[]) => boolean = //
  allPass([
    flow(get('length'), eq(2)),
    every(
      allPass([
        negate(isNaN), //
        isNumber,
      ]),
    ),
  ])

export const getCoordinates: (coordinates: string | null | undefined) => [number, number] | undefined = flow(
  split(','),
  map(trim),
  filter(isFilled),
  map(Number),
  ifThen(isValidCoordinates, identity),
  toUndefinedIfEmpty,
)
